import { call, put, select, takeEvery } from 'redux-saga/effects';
import { dealerActionCreators, DealerActionKeys, FetchDealerList, IDealerMin } from '..';
import { IState } from '../..';
import { businessEntityActionCreators } from '../../businessEntity';
import { FilterTypes, getFilteredSalesDistricts, getFilters, ISalesDealersFilters, isFiltered } from '../../filters';
import { uiActionCreators } from '../../ui';
import * as api from '../dealerApi';

function* fetchDealerListSaga(action: FetchDealerList) {
  // check to see if all the dealers are already loaded
  const fullyLoaded: boolean = yield select((state: IState) => state.dealer.fullListLoaded);

  if (!fullyLoaded) {
    const loadStartFunc = action.payload.showFullPageLoading
      ? uiActionCreators.showFullPageLoading
      : dealerActionCreators.toggleListLoading;
    const loadEndFunc = action.payload.showFullPageLoading
      ? uiActionCreators.hideFullPageLoading
      : dealerActionCreators.toggleListLoading;

    yield put(loadStartFunc());

    const filters: ISalesDealersFilters = yield select((state: IState) => getFilters(state, FilterTypes.salesDealers));
    const filtered: boolean = yield select((state: IState) => isFiltered(state, FilterTypes.salesDealers));

    const sds: string[] = yield select((state: IState) => getFilteredSalesDistricts(state, filters));

    const dealers: IDealerMin[] = yield call(api.fetchDealers, sds, filters.searchTerm);

    yield put(
      businessEntityActionCreators.addNames(dealers.map(x => ({ businessEntityId: x.businessEntityId, name: x.name })))
    );
    yield put(dealerActionCreators.fetchDealerListFulfilled({ dealers, full: !filtered }));
    yield put(loadEndFunc());
  }
}

export function* watchFetchDealerList() {
  yield takeEvery(DealerActionKeys.FETCH_DEALER_LIST, fetchDealerListSaga);
}
